import { get } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';

import { getPresetByName } from '../../common/components/AdvancedSearch/selectors';
import { dashboardTableId } from './component';

export const mapChargersAreLoading = (state) => get(state, 'dashboard.mapChargers.areLoading', false);

export const mapChargersAreLoaded = (state) => get(state, 'dashboard.mapChargers.areLoaded', false);

export const mapChargersLoadedCount = (state) => get(state, 'dashboard.mapChargers.loadedCount', 0);

export const mapChargersTotalCount = (state) => get(state, 'dashboard.mapChargers.totalCount', 1);

export const getDashboardAdvancedQuery = createSelector([(state) => getPresetByName(state, dashboardTableId)], (dashboardPreset) =>
  dashboardPreset ? dashboardPreset.query : null,
);

export const getMapChargersPerRequest = (state) => get(state, 'appConfig.config.dashboard.map.chargersPerRequest', 1000);

export const getFilterStarted = (state) => get(state, 'dashboard.filterStarted', false);